import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { OfframpService } from '../../services/offramp.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

const defaults = {
  notif: {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 50
  }
};

@Component({
  selector: 'app-add-offramp-exchange-withdrawal',
  templateUrl: './add-offramp-exchange-withdrawal.component.html',
  styleUrls: ['./add-offramp-exchange-withdrawal.component.css']
})
export class AddOfframpExchangeWithdrawalDialog implements OnInit {
  element: any = {};
  myForm: any;
  liquidityProviderList: any[] = [];
  bankList: any[] = [];
  quoteList: any[] = [];
  isEditMode: boolean = false;
  recordId: string = '';
  currentUserDisplay: string = '';
  statusOptions = ['REQUEST', 'PENDING', 'PROCESSING', 'APPROVED', 'COMPLETED', 'FAILED', 'REJECTED', 'CANCELLED'];

  constructor(
    public dialogRef: MatDialogRef<AddOfframpExchangeWithdrawalDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notifSer: NotificationsService,
    public fb: FormBuilder,
    public userService: UserService,
    public offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.element = data.record || {};
    this.isEditMode = !!this.element._id;
    this.recordId = this.element._id || '';

    const loggedInUser = this.userService.getUserDetails();
    this.currentUserDisplay = loggedInUser ? `${loggedInUser.name} (${loggedInUser.email})` : '';

    this.myForm = this.fb.group({
      adminid: [
        this.element.adminid ? (this.element.adminid._id || this.element.adminid) : (loggedInUser ? loggedInUser._id : ''),
        [Validators.required]
      ],
      liquidity_provider_id: [
        this.element.liquidity_provider_id ? (this.element.liquidity_provider_id._id || this.element.liquidity_provider_id) : '',
        [Validators.required]
      ],
      bank_id: [
        this.element.bank_id ? (this.element.bank_id._id || this.element.bank_id) : '',
        [Validators.required]
      ],
       ref_id: [
        this.element.ref_id ? (this.element.ref_id || this.element.ref_id) : '',
        [Validators.required]
      ],
      exchange_quote_id: [
        this.element.exchange_quote_id ? (this.element.exchange_quote_id._id || this.element.exchange_quote_id) : '',
        [Validators.required]
      ],
      amount: [this.element.amount || 0, [Validators.required, Validators.min(0)]],
      status: [this.element.status || 'REQUEST', [Validators.required]],
    });
  }

  ngOnInit() {
    this.loadLiquidityProviderList();
    this.loadBankList();
    this.loadQuoteList();
  }

  loadLiquidityProviderList() {
    const filter = { _csrf: this.data._csrf, limit: 10000, page: 1 };
    this.offrampService.getAllOfframpExchanges(filter).subscribe(
      (response: any) => {
        this.liquidityProviderList = (response && response.data) || [];
      },
      () => {
        this.notifSer.error('Error', 'Failed to load liquidity provider list', defaults.notif);
        this.liquidityProviderList = [];
      }
    );
  }

  loadBankList() {
    this.userService.getBanks().subscribe(
      (response: any) => {
        this.bankList = response || [];
      },
      () => {
        this.notifSer.error('Error', 'Failed to load bank list', defaults.notif);
        this.bankList = [];
      }
    );
  }

  loadQuoteList() {
    const filter = { _csrf: this.data._csrf, limit: 10000, page: 1 };
    this.offrampService.getAllOfframpExchangeQuotes(filter).subscribe(
      (response: any) => {
        this.quoteList = (response && response.data) || [];
      },
      () => {
        this.notifSer.error('Error', 'Failed to load exchange quote list', defaults.notif);
        this.quoteList = [];
      }
    );
  }

  saveWithdrawal() {
    const { notif } = defaults;

    if (this.myForm.invalid) {
      this.notifSer.error('Error', 'Please fill all required fields', notif);
      return;
    }

    this.spinnerService.show();

    const formData: any = {
      ...this.myForm.value,
      _csrf: this.data._csrf
    };

    if (this.isEditMode) {
      formData._id = this.recordId;
      this.offrampService.updateOfframpExchangeWithdrawal(formData).subscribe(
        (response) => {
          this.spinnerService.hide();
          if (response.status || response.success) {
            this.notifSer.success('Success', response.message || 'Exchange withdrawal updated successfully', notif);
            this.dialogRef.close({ success: true, data: response });
          } else {
            this.notifSer.error('Error', response.message || 'Failed to update exchange withdrawal', notif);
          }
        },
        (err) => {
          this.spinnerService.hide();
          this.notifSer.error('Error', (err.error && err.error.message) || 'Failed to update exchange withdrawal', notif);
        }
      );
    } else {
      this.offrampService.createOfframpExchangeWithdrawal(formData).subscribe(
        (response) => {
          this.spinnerService.hide();
          if (response.status || response.success) {
            this.notifSer.success('Success', response.message || 'Exchange withdrawal created successfully', notif);
            this.dialogRef.close({ success: true, data: response });
          } else {
            this.notifSer.error('Error', response.message || 'Failed to create exchange withdrawal', notif);
          }
        },
        (err) => {
          this.spinnerService.hide();
          this.notifSer.error('Error', (err.error && err.error.message) || 'Failed to create exchange withdrawal', notif);
        }
      );
    }
  }

  onCancel() {
    this.dialogRef.close({ success: false });
  }
}



// WEBPACK FOOTER //
// ./src/app/offramp-exchange-withdrawals/add-offramp-exchange-withdrawal/add-offramp-exchange-withdrawal.component.ts